module.exports = __webpack_public_path__ + "img/loader.d4e34261.gif";